<template>
  <b-container class="p-0 6" :style="'min-height:' + minHeight + 'px; max-width:' + maxWidth + 'px;'">
    <b-row class="no-gutters 7 " :style="'width: 100%; line-height:' + minHeight + 'px;'" >
      <b-col class="text-center p-0 8" style="width: 100%">
          <b-img
                v-if="!checkIsCordova"
                :class="{'zoom-in' : enableZoomIn}"
                @click="onImageZoom"
                :src="$secureUrl(src)"
                :style="'max-height:' + maxHeight + 'px;' + 'max-width:' + maxWidth + 'px;'"
          >
          </b-img>
          <b-img
                v-else
                :class="{'zoom-in' : enableZoomIn}"
                @click="onImageZoom"
                :src="$secureUrl(addCordovaUrl + src)"
                :style="'max-height:' + maxHeight + 'px;' + 'max-width:' + maxWidth + 'px;'"
          >
          </b-img>
      </b-col>
    </b-row>
    <div class="text-center">
      <b-button-group :class="organizationPicture? '' : 'mt-2'">
        <b-button
            v-if="zoom"
            class="width-icon-button"
            variant="plm-action"
            @click="onImageZoom"
        >
          <font-awesome-icon icon="search" />
        </b-button>
        <b-button
            v-if="remove"
            class="width-icon-button"
            variant="plm-action"
            @click="onDeleteImage"
            :disabled="readOnlyInputs"
        >
          <font-awesome-icon icon="trash" />
        </b-button>
         <b-button
             class="width-icon-button"
             variant="plm-action"
             v-if="edit"
             @click="onEditImage"
             :disabled="readOnlyInputs"
         >
           <font-awesome-icon icon="pencil-alt" />
         </b-button>
      </b-button-group>
    </div>
  </b-container>
</template>

<script>
import FileUpload from "@/components/FileUpload";


export default {
  name: "ImageViewer",
  components: {FileUpload},

  created() {
  },

  mounted(){
  },
  computed:{
    checkIsCordova(){
      return window.isCordova
    },
    addCordovaUrl(){
      return window.cordovaUrl
    }
  },
  methods: {
    async onImageZoom(){
      this.$emit('zoomImage');
    },

    async onDeleteImage(){
      if(await DialogManager.yesNo($tr('imageViewer.delete','Deleting image'),
          $tr('imageViewer.sure.delete','Are you sure you want to delete this image?'))){
        this.$emit('removeImage');
      }
    },

    onEditImage(){
      this.$emit('editImage');
    }
  },

  props: {
    editImage:              Function,
    removeImage:            Function,
    zoomImage:              Function,


    minHeight:                {type: Number,             default:null },
    maxHeight:                {type: Number,             default:null },
    maxWidth:                 {type: Number,             default:null },
    src:                      {type: String,             default:"" },
    zoom:                     {type: Boolean,            default: false},
    remove:                   {type: Boolean,            default: false},
    edit:                     {type: Boolean,            default: false},
    enableZoomIn:             {type: Boolean,            default: false},
    readOnlyInputs:           {type: Boolean,            default: false},
    organizationPicture:      {type: Boolean,            default: false},
  },

  data: () => ({
  })
}
</script>

